<template>
  <div class="chart_component">
    <main>
      <span class="title">{{ title }}</span>
    </main>

    <div class="icon">
      <span>
        <i :class="icon"></i>
      </span>
      <p
        class="number"
        @click="is_model_open = true"
        :class="image ? 'image_statisics' : ''"
      >
        <span>{{ number }}</span>
        <span v-if="image" class="mr-2"
          ><i class="fas fa-eye" style="font-size: 25px"></i
        ></span>
      </p>
    </div>
    <v-dialog v-model="is_model_open" v-if="image" width="700">
      <v-card>
        <img :src="image" class="w-100" alt="" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_model_open: false,
    };
  },
  props: {
    number: {
      deafult: 0,
    },
    icon: {
      default: "fal fa-analytics",
    },
    title: {
      deafult: "title",
    },
    image: {
      type: String,
      deafult: null,
    },
  },
};
</script>
<style lang="scss" scoped>
.image_statisics {
  cursor: pointer;
  &:hover {
    i {
      color: gray;
    }
  }
}
</style>
